export class SortConf {
  constructor(
    public field: string,
    public ascending: boolean
  ) {}
}
